import { postV1CompaniesCompanyIdProjectsProjectIdPdfs } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import { Project } from '~hooks/useProjects/models';
import useRenderedPdfDownload from '~hooks/useRenderedPdfDownload/useRenderedPdfDownload';
import { useStores } from '~store';
import { RTU_WAITING_TIMEOUT_IN_MS } from '~utils/rtu/rtu-utils';
import { getEffectiveUserCompanyId } from '~utils/user/user-utils';

export default function useServerQuotePdf() {
  const { userStore } = useStores();
  const { downloadRenderedPdf } = useRenderedPdfDownload();

  return useCallback(
    (project: Project) =>
      downloadRenderedPdf({
        failureMessage: t('project.quote_pdf.generation_failed'),
        render: () =>
          postV1CompaniesCompanyIdProjectsProjectIdPdfs({
            path: {
              'company-id': getEffectiveUserCompanyId(userStore),
              'project-id': project.id,
            },
          }),
        timeoutMs: RTU_WAITING_TIMEOUT_IN_MS,
      }),
    [downloadRenderedPdf, userStore],
  );
}
